import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import {
  AdminSentNotificationDto,
  NotificationReceiversCountDto,
  NotificationTargetingRequest,
  PaginateQuery,
  SendNotificationRequest,
} from "../../interfaces";
import { Paginated } from "../../models";

export const notificationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    sendNotification: builder.mutation<any, SendNotificationRequest>({
      query: (data) => ({
        url: "/api/notification",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Notification"],
    }),
    getNotificationReceiversCount: builder.query<
      NotificationReceiversCountDto,
      NotificationTargetingRequest
    >({
      query: (data) => ({
        url: "/api/notification/receivers-count",
        method: "POST",
        body: data,
      }),
    }),
    getAdminSentNotifications: builder.query<
      Paginated<AdminSentNotificationDto>,
      PaginateQuery
    >({
      query: (data) => ({
        url: buildPaginationQueryString(data, "/api/notification/admin-sent"),
      }),
      providesTags: ["Notification"],
    }),
    deleteNotification: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/notification/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Notification"],
    }),
  }),
});

export const {
  useSendNotificationMutation,
  useGetNotificationReceiversCountQuery,
  useGetAdminSentNotificationsQuery,
  useDeleteNotificationMutation,
} = notificationApi;
